import { createTheme } from "@mui/material/styles";
import { themeOptions } from "./theme";

// Theme for chrome (navbar + footer) mounted inside the legacy document, whose
// <html> font-size is scaled down responsively for the legacy app. MUI sizes
// almost everything in rem, which always resolves against <html>, so that
// scaling would shrink the chrome and everything it portals to <body> (drawers,
// menus, dialogs). Emit px instead of rem so the chrome renders at a constant
// size regardless of the legacy root scaling: one switch that covers every
// current and future chrome component. The v2 app keeps the rem-based theme (it
// has no <html> scaling and rem lets it honor the browser's font-size
// accessibility setting).
const chromeTheme = createTheme({
  ...themeOptions,
  typography: {
    ...themeOptions.typography,
    pxToRem: (size) => `${size}px`,
  },
});

export default chromeTheme;
